import React from 'react';
import { cn } from '../../lib/utils';

/** Quiet unit-card section label (Lessons, Learning Objectives, etc.). */
export const unitSectionHeadingClass =
    'text-xs font-semibold uppercase tracking-wide text-gray-600';

export function UnitSectionHeading({
    title,
    className,
    hidden,
}: {
    title: string;
    className?: string;
    hidden?: boolean;
}) {
    return (
        <h4
            hidden={hidden}
            className={cn('mb-3 px-1', unitSectionHeadingClass, className)}
        >
            {title}
        </h4>
    );
}
